"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var forms_1 = require("@angular/forms");
var eligibility_1 = require("@bhtp-client-api/eligibility");
var masked_datepicker_1 = require("./../masked-datepicker");
var validation_messages_1 = require("./../validation-messages");
var type_ahead_1 = require("./../type-ahead");
var misc_1 = require("./../misc");
var form_controls_1 = require("./../form-controls");
var _1 = require("./");
exports.DECLARED_AND_EXPORTED_COMPONENTS = [
    _1.FlightBuilderComponent,
    _1.FlightInputComponent,
    _1.PostponedFlightsComponent,
    _1.PostponedFlightsWrapperComponent
];
var BhtpFlightBuilderModule = (function () {
    function BhtpFlightBuilderModule() {
    }
    return BhtpFlightBuilderModule;
}());
BhtpFlightBuilderModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            forms_1.FormsModule,
            forms_1.ReactiveFormsModule,
            masked_datepicker_1.BhtpMaskedDatePickerModule,
            validation_messages_1.BhtpValidationMessagesModule,
            type_ahead_1.BhtpTypeaheadModule,
            misc_1.BhtpMiscModule,
            eligibility_1.BhtpEligibilityModule,
            form_controls_1.BhtpFormControlsModule
        ],
        declarations: [
            exports.DECLARED_AND_EXPORTED_COMPONENTS
        ],
        exports: [
            exports.DECLARED_AND_EXPORTED_COMPONENTS
        ]
    })
], BhtpFlightBuilderModule);
exports.BhtpFlightBuilderModule = BhtpFlightBuilderModule;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/flight-builder/flight-builder.module.js